import { makeApiCall } from "../apiRequest";

export default {
  state: {},
  getters: {
    getAdminData: (state) => state.adminData,
  },
  actions: {
    async userLogin({ commit }, payload) {
      const response = await makeApiCall("auth/login", "POST", payload);
      if (response.data.data) {
        const token = response.data.data.token;
        localStorage.setItem("super_roomround_access_token", token);
        //localStorage.setItem('user_id',response.data.data.user.id);
      } else {
        return response;
      }
      return response;
    },
    async getAdminData({ commit }, id) {
      let url = `auth/loginAsAdmin?organizationId=${id}`;
      const response = await makeApiCall(url, "GET");
      if (!response.error) {
        commit("setAdminData", response.data);
      }
      return response;
    },
    async adminLogin({commit},payload){
      const url = `auth/login`;
      const response = await makeApiCall(url,'POST',payload)
      return response;
    }
  },
  mutations: {
    setAdminData: (state, payload) => (state.adminData = payload),
  },
};
